export const normalizeHistoryRemarks = (value) => {
  if (value == null || value === "") return "N/A";
  if (typeof value === "string") return value.trim() || "N/A";
  if (typeof value === "object") {
    if (Array.isArray(value)) {
      return value.length ? value.map(String).join(", ") : "N/A";
    }
    const values = Object.values(value).filter(
      (entry) => entry != null && String(entry).trim() !== ""
    );
    return values.length ? values.map(String).join(", ") : "N/A";
  }
  return String(value);
};

export const getHistoryStatusLabel = (item = {}) => {
  if (item.statusName) return item.statusName;
  if (typeof item.status === "string" && item.status.trim()) return item.status;
  if (item.isActive === false) return "Inactive";
  if (item.isActive === true) return "Active";
  return "N/A";
};

export const mapRfidHistoryData = (list = []) =>
  list.map((item, index) => ({
    sNo: item.sNo ?? item.SNo ?? index + 1,
    statusName: getHistoryStatusLabel(item),
    remarks: normalizeHistoryRemarks(
      item.remarks ?? item.Remarks ?? item.installationRemarks
    ),
    actionTakenBy:
      item.actionTakenBy ??
      item.ActionTakenBy ??
      item.modifiedBy ??
      item.installedBy ??
      "N/A",
    modifiedOn:
      item.modifiedOn ?? item.ModifiedOn ?? item.lastModifiedOn ?? "",
  }));

export const getRfidRowId = (row) =>
  row?.rfidMasterId ?? row?.assetRfidId ?? row?.rfidId ?? null;

export const getRfidHistoryKey = (id) =>
  id == null || id === "" ? null : String(id);
